<template>
  <div v-show="showPopup">
    <van-popup v-model="isShowOverlay"
      :overlay="isShowOverlay"
      @open="open"
      @close="close"
      @click-overlay="close"
      position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="请选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirm"
        @cancel="cancel"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'datePicker',
  props: {
    showPopup: {
      type: Boolean,
      default: false
    },
    // minDate: {
    //   type: String,
    //   default: function () {
    //     return new Date(new Date().getFullYear()-50, 0, 1);
    //   }
    // },
    // maxDate: {
    //   type: String,
    //   default: function () { 
    //     return new Date(new Date().getFullYear()+50, 0, 1);
    //   }
    // }
  },
  watch: {
    showPopup(newValue) {
      this.isShowOverlay = newValue;
    }
  },
  data () {
    return {
      isShowOverlay: false,
      minDate: new Date(2016, 0, 1),
      maxDate: new Date(2026, 12, 31),
      currentDate: new Date(), // 默认选中当天日期
    }
  },
  created() {

  },
  mounted() {
    /**
     * 特殊需求：选择日期的最大日期、最小日期；默认选中当天的日期
     * 日期的最小值、最大日期 可以自定义，
     */
    // 自定义日期的最小值-最大值
    let min = new Date().getFullYear()-50;
    let max = new Date().getFullYear()+50;
    this.minDate = new Date(min, 0, 1);
    this.maxDate = new Date(max, 12, 1);
  },
  methods: {
    // 日期组件自定义格式
    formatter (type, value) {
      if (type == 'year') {
        this.value1 = value   // 可以拿到当前点击的数值
        return `${value}年`
      } else if (type == 'month') {
        this.value2 = value
        return `${value}月`
      }
      this.value3 = value
      return `${value}日`
    },
    confirm () {
      var selectTime = `${this.value1}-${this.value2}-${this.value3}`
      // console.log('用户选择的日期', new Date(this.currentDate).getTime(), selectTime);
      this.$emit('dateInput', selectTime);
      this.$emit('isShow', false);
    },
    cancel () {
      this.$emit('isShow', false);
    },
    open() {
      this.isShowOverlay = true;
    },
    close() {
      this.isShowOverlay = false;
      this.$emit('isShow', false);
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/VantDatePicker.vue